import { render } from "./TeachingView.vue?vue&type=template&id=0d72277b&scoped=true"
import script from "./TeachingView.vue?vue&type=script&lang=js"
export * from "./TeachingView.vue?vue&type=script&lang=js"

import "./TeachingView.vue?vue&type=style&index=0&id=0d72277b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d72277b"]])

export default __exports__